import React, { createContext, useContext, useState, useCallback } from 'react';
import BookingModal from '../components/BookingModal';

const BookingContext = createContext(null);

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) {
    throw new Error('useBooking must be used within BookingProvider');
  }
  return ctx;
};

export const BookingProvider = ({ children }) => {
  const [modal, setModal] = useState({
    show: false,
    title: 'Book an Appointment',
    serviceName: '',
    planName: '',
    type: 'appointment_request'
  });

  const openBooking = useCallback((options = {}) => {
    setModal({
      show: true,
      title: options.title || 'Book an Appointment',
      serviceName: options.serviceName || options.service || '',
      planName: options.planName || '',
      type: options.type || 'appointment_request'
    });
  }, []);

  const closeBooking = useCallback(() => {
    setModal((m) => ({ ...m, show: false }));
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking, closeBooking }}>
      {children}
      <BookingModal
        show={modal.show}
        onClose={closeBooking}
        title={modal.title}
        serviceName={modal.serviceName}
        planName={modal.planName}
        type={modal.type}
      />
    </BookingContext.Provider>
  );
};
